/* import __COLOCATED_TEMPLATE__ from './suggestion-data-connector.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();